import { Component } from '@angular/core';
import { AbstractAppComponent } from '@shared/components/abstracts/abstract-app.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent extends AbstractAppComponent {
  constructor() {
    super(
      `Analysez l'historique d'un véhicule`,
      `Explorez l'historique d'un véhicule grâce à notre service de vérification approfondie et recevez un rapport exhaustif contenant des détails sur les dommages, le kilométrage, les vols, ainsi que d'autres éléments essentiels.`
    );
  }
}
